import { Box, Popover, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { getYCenterStyles } from "../theme/mixins";

export type DropdownOptionClickEvent = React.MouseEvent<HTMLDivElement, MouseEvent> | React.MouseEvent<HTMLButtonElement, MouseEvent>;

export type DropdownOption = {
    label: string | (() => React.ReactNode);
    icon?: React.ReactNode;
    onClick: (e: DropdownOptionClickEvent) => void;
}

export type OptionsDropdownProps = {
    trigger: (open: (el: HTMLElement) => void) => React.ReactNode;
    options: DropdownOption[];
}

export const OptionsDropdown = (props: OptionsDropdownProps) => {
    const { trigger, options } = props;

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    return <>
        {trigger((el) => setAnchorEl(el))}

        <Popover
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            {options.map((option, index) => <Option
                key={index}
                {...option}
                isLast={index === options.length - 1}
                hideDropdown={() => setAnchorEl(null)}
            />)}
        </Popover>
    </>
}

export type DropdownOptionProps = DropdownOption & {
    isLast: boolean;
    hideDropdown: () => void;
}

export const Option = (option: DropdownOptionProps) => {
    const theme = useTheme();

    return <Box
        onClick={(e) => {
            option.onClick(e);
            option.hideDropdown();
        }}
        sx={{
            ...getYCenterStyles(),
            gap: 1,
            minWidth: 240,
            maxWidth: 320,
            paddingX: 2,
            paddingY: 1.6,
            borderBottom: option.isLast ? undefined : `1px solid ${theme.palette.divider}`,
            cursor: "pointer",
            transition: "background-color 0.2s",
            "&:hover": {
                backgroundColor: theme.palette.action.hover,
            }
        }}
    >
        {option.icon}
        {typeof option.label === "string" ? <Typography variant="body2">{option.label}</Typography> : option.label()}
    </Box>
}